import React, { useState } from "react";
import tw, {theme} from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Typist from "react-typist";

import { HashLink } from 'react-router-hash-link';
import Header, { NavLink, NavLinks, PrimaryLink, LogoLink, NavToggle, DesktopNavLinks } from "../headers/light.js";
// import ResponsiveVideoEmbed from "../../helpers/ResponsiveVideoEmbed.js";
import { ReactComponent as LinkedinIcon } from "feather-icons/dist/icons/linkedin.svg";

// import CellImage from  "https://appseed-147a1.kxcdn.com/static/assets/img/web-app-generator-appseed.png"
import MainImage from "../../images/top/main-image-001.png";

const StyledHeader = styled(Header)`
  ${tw`pt-4 max-w-none`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;
const Container = styled.div`
  ${tw`relative -mx-8 -mt-8 sm:pb-24 bg-center bg-cover bg-gray-900 rounded-b-xl `}
`;

// const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-primary-500 opacity-25`;
const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-xl mx-auto`;
const TwoColumn = tw.div`pt-24 pb-12 sm:pb-48 px-4 flex justify-between items-center flex-col lg:flex-row`;
const LeftColumn = tw.div`flex sm:pt-32 flex-col items-center lg:block lg:w-1/2 lg:flex-shrink-0`;
const RightColumn = tw.div`w-full sm:pt-32 sm:w-5/6 lg:w-1/2 mt-4 lg:mt-0 lg:pl-8 lg:transform lg:translate-x-8`;

const Heading = styled.h1`
  ${tw`text-3xl text-center lg:text-left sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-100 leading-none`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const Highlight = styled.span`
  ${tw`relative inline-flex whitespace-nowrap text-2xl sm:text-4xl lg:text-5xl xl:text-6xl text-primary-500 px-4 -mx-4 py-2`}
  width: 11.5em;
  max-width: calc(100vw - 3rem);
  &::before {
    content: "";
    ${tw`absolute inset-0 bg-gray-100 transform -skew-x-12 -z-10`}
  }
`;

const Notification = tw.span`inline-block my-4 pl-3 py-1 text-gray-100 border-l-4 border-blue-500 font-medium text-sm`;
const Description = tw.p`mt-8 max-w-2xl text-center lg:text-left text-base sm:text-lg text-gray-300 font-medium leading-relaxed`;
const Actions = tw.div`flex flex-col sm:flex-row items-center mt-8 sm:mt-10`;

const PrimaryAction = tw(HashLink)`
  text-lg p-4 sm:text-base sm:px-8 sm:py-4
  bg-gray-100 text-primary-500 font-bold rounded shadow transition duration-700 
  hocus:bg-primary-500 hocus:text-gray-100 hover:no-underline focus:shadow-outline`;

const LinkedinAction = tw.a`
  flex items-center mt-4 sm:mt-0 sm:ml-4 text-lg p-4 sm:text-base sm:px-8 sm:py-4
  border border-gray-400 text-gray-100 font-bold rounded transition duration-300
  hocus:border-primary-500 hocus:text-primary-500 hover:no-underline focus:shadow-outline`;

// const StyledResponsiveVideoEmbed = styled(ResponsiveVideoEmbed)`
//   padding-bottom: 56.25% !important;
//   padding-top: 0px !important;
//   ${tw`rounded`}
//   iframe {
//     ${tw`rounded bg-black shadow-xl`}
//   }
// `;

export default () => {
  const [animationKey, setAnimationKey] = useState(0);

  const navLinks = [
    <NavLinks key={1}>
      <NavLink id="services-link" as={HashLink} to="#services" smooth>
        Services
      </NavLink>
      <NavLink as={HashLink} to="#tech" smooth>
        Skills
      </NavLink>
      <NavLink id="experience-link" as={HashLink} to="#experience" smooth>
        Experience
      </NavLink>
      <NavLink id="portfolio-link" as={HashLink} to="#portfolio" smooth>
        Work
      </NavLink>
    </NavLinks>,
    <NavLinks key={2}>
      <PrimaryLink
        href="https://linktr.ee/dduffy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Contact / Links
      </PrimaryLink>
    </NavLinks>
  ];

  const personalLogo = (
    <LogoLink href="/" aria-label="Darragh Duffy home">
      Darragh Duffy
    </LogoLink>
  );

  return (
    <Container 
      css={[
      css({
        // Grab values from your config with the theme import
        background: `linear-gradient(
          ${theme`colors.gray.800`} 25%,
          ${theme`colors.gray.700`} 75%
          
        )`
      })
    ]}>
      {/* <OpacityOverlay /> */}
      <StyledHeader links={navLinks} logoLink={personalLogo} />
      <HeroContainer>
        <TwoColumn>
          <LeftColumn>
            <Notification>Senior Pipeline Engineer · Python · APIs · Creative Automation</Notification>
            <Heading>
              <span>Software engineering for</span>
              <br/>
              <Highlight>
                <Typist
                  key={animationKey}
                  cursor={{ blink: true }}
                  startDelay={700}
                  onTypingDone={() => setAnimationKey(key => key + 1)}
                >
                  <span>creative production</span>
                  <Typist.Backspace count={19} delay={1800} />
                  <span>pipeline automation</span>
                  <Typist.Backspace count={19} delay={1500} />
                  <span>connected workflows</span>
                  <Typist.Backspace count={19} delay={1500} />
                  <span>API integrations</span>
                  <Typist.Backspace count={16} delay={1800} />
                </Typist>
              </Highlight>
            </Heading>
            <Description>
              I’m Darragh Duffy, a Dublin-based engineer with 15+ years across software, VFX,
              animation and production technology. I build Python tools, APIs and automated systems.
            </Description>
            <Actions>
              <PrimaryAction to="#portfolio" smooth>View my work</PrimaryAction>
              <LinkedinAction
                href="https://www.linkedin.com/in/darraghduffydev/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedinIcon tw="w-5 h-5 mr-2" />
                LinkedIn
              </LinkedinAction>
            </Actions>
          </LeftColumn>
          <RightColumn>
            {/* <StyledResponsiveVideoEmbed
              url= "https://appseed-147a1.kxcdn.com/static/assets/img/web-app-generator-appseed.png"//player.vimeo.com/video/374265101?title=0&portrait=0&byline=0&autoplay=0&responsive=1"
              background="transparent"
            /> */}
            <img tw="object-scale-down h-48 sm:h-128 w-full" alt="Abstract illustration of connected production technology" src={MainImage}/>
            {/* <CellImage /> */}
            <a tw="text-gray-600 hover:text-blue-600 float-right"  href='https://pngtree.com/so/the-internet'>credit</a>

          </RightColumn>
        </TwoColumn>
      </HeroContainer>
    </Container>
  );
};
